export const SSE_CONFIG = {
  MAX_FAILURES_BEFORE_FALLBACK: 5,
  FAILURE_RESET_TIME: 60_000,
  MAX_RECONNECT_ATTEMPTS: 10,
  FIXED_DELAY: 20_000,
  CONNECT_TIMEOUT: 5_000,
}
